import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Select-root_1tCgo",
  "small": "Select-small_3Poor",
  "is-disabled": "Select-is-disabled_tqx0q",
  "is-active": "Select-is-active_2YQ85",
  "is-readOnly": "Select-is-readOnly_3WbSG",
  "has-error": "Select-has-error_WZsGV",
  "block": "Select-block_1TOe-"
};
export default class Select extends React.Component {
  static defaultProps = {
    active: false,
    disabled: false,
    readOnly: false,
    variant: ['default'],
    error: ''
  };
  renderItem = (item, index) => {
    if ('value' in item && !Array.isArray(item.value) && !Array.isArray(item.text)) {
      return /*#__PURE__*/_jsx("option", {
        value: item.value,
        children: item.text
      }, `key-${item.value}-${index}`);
    }
    return Object.keys(item).map(label => Array.isArray(item[label]) ? /*#__PURE__*/_jsx("optgroup", {
      label: label,
      children: item[label].map(this.renderItem)
    }, label) : null);
  };
  oldValueExist = item => {
    const {
      value
    } = this.props;
    if ('value' in item) {
      return item.value === value;
    }
    return Object.keys(item).some(key => Array.isArray(item[key]) ? item[key].some(this.oldValueExist) : false);
  };
  render() {
    const {
      active,
      className,
      disabled,
      readOnly,
      error,
      values,
      placeholder,
      variant,
      isField,
      popoverIcon,
      ...inputProps
    } = this.props;
    const selectClassName = clsx(styles.root, className, {
      'is-active': active,
      [styles.block]: variant.indexOf('block') > -1,
      [styles['is-disabled']]: disabled,
      [styles['is-readOnly']]: readOnly,
      [styles['has-error']]: error,
      'has-error': error,
      [styles.small]: variant.indexOf('small') > -1
    });
    const invalidValue = !values.some(this.oldValueExist);
    return /*#__PURE__*/_jsxs("select", {
      className: selectClassName,
      disabled: disabled,
      "aria-readonly": readOnly,
      ...inputProps,
      children: [placeholder && /*#__PURE__*/_jsx("option", {
        className: styles.placeholder,
        value: "",
        disabled: inputProps.required && !invalidValue,
        children: placeholder
      }), values.map(this.renderItem)]
    });
  }
}